// extracted by mini-css-extract-plugin
export default {"nyButton":"nyButton--vnJv2","icon":"icon--QspEA","sugrob":"sugrob--ie_eH"};